import { render, staticRenderFns } from "./LoopPanel.vue?vue&type=template&id=48c4ee80&scoped=true&"
import script from "./LoopPanel.vue?vue&type=script&lang=js&"
export * from "./LoopPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c4ee80",
  null
  
)

export default component.exports